<template>
    <div>
        <div class="sousuo">
            <van-search
                    v-model="money"
                    placeholder="要搜索的手机号 / 姓名"
                    shape="round"
                    style="width: 70%;"
            >
            </van-search>
            <span class="soubtn" @click="onSearch">搜索</span>
            <span class="soubtn" @click="sanke">散客</span>
        </div>
        <div class="fw-mbs">
            <el-card class="box-card" v-for="item in members">
                <div slot="header" class="clearfix">
                    <div class="fw-mb">
                        <div style="display: flex;width: 80%">
                            <div class="mb-name">
                                <img src="./../../assets/hyname.png" class="kdimg" />
                                <span >{{item.memberName}}</span>
                            </div>
                            <div>
                                <span v-if="item.sex == 0">未知</span>
                                <span v-if="item.sex == 1">男</span>
                                <span v-if="item.sex == 2">女</span>
                                <span style="line-height: 29px;font-size: 9px;margin-left: 3px" v-if="item.phone">({{ item.phone }})</span>
                            </div>
                        </div>
                        <div class="djnr">
                            <img src="./../../assets/vip.png" class="kdimg" />
                            <el-button class="memberbtn1" type="text" @click="setMember(item)">选择</el-button>
                        </div>
                    </div>
<!--                    <el-button class="memberbtn" type="text" @click="setMember(item)">-->
<!--                        选择-->
<!--                    </el-button>-->
                </div>
                <div class="card-item" v-if="item.memberCards.length>0" v-for="card in item.memberCards">
                    <div class="kaneirong">
                        <span class="cardname"> {{card.cardName}} ( {{card.itemDiscount}}折 )</span>
                        <div class="djnr">
                            <img src="./../../assets/banka.png" class="bkimg" />
                            <el-button class="memberbtn1" type="text" @click="setMember(item,card)">选择</el-button>
                        </div>
                    </div>
                    <div class="kaye">
                        <span style="line-height: 30px">卡金 : ¥{{card.balance}}</span>
                        <span style="line-height: 30px">赠送金 : ¥{{card.giveBalance==null?'0':card.giveBalance}}</span>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>

    import {getCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId:'',
                token:'',
                money:'',
                members:[],
            };
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            chushi(){
                this.money=''
            },

            async onSearch() {
                if (!this.money) {
                    this.$notify("请输入要搜索的手机号 / 姓名!");
                    return;
                }
                let data = {
                    deptId: this.deptId,
                    name: this.money,
                };
                let res = await this.$get("/fw/getFwMembers", data);
                if (res.code == 200) {
                    this.members = res.list;
                }
            },
            setMember(mb,card){
                let data={
                    mb:mb,
                    card:card,
                }
                this.$emit('setMember',data)
            },
            sanke() {
                this.$emit('sanke')
            },

        },
    };
</script>

<style lang="scss" scoped>
 .sousuo{
     padding: 15px;
     margin-top: 12px;
     display: flex;
     flex-direction: row;
     justify-content: center;
     align-items: center
 }
    .fw-mbs{
        display: flex;
        flex-direction: column;
        border-top: #dddddd solid 1px;
        padding: 10px;
    }
    .fw-mb{
        display: flex;
        flex-direction: row;
        height: 25px;
        text-align: center;
        font-size: 12px
    }
 .mb-name{
     width: 30%;
     line-height: 25px;
     white-space: nowrap;
     text-overflow: ellipsis;
     overflow: hidden;
     margin-right: 10px;
     text-align: left;
     display: flex;
     align-items: center;
 }
     /deep/ .el-card__body {
         padding: 10px;
     }
     /deep/ .el-card__header {
         padding: 10px;
         border-bottom: 0.02667rem solid #EBEEF5;
         box-sizing: border-box;
         font-size: 13px;
     }

 .soubtn {
     width: 40px;
     font-size: 14px;
     margin: 0px 3px;
 }
 .memberbtn {
     float: right;
     padding: 3px 0;
     margin-top: -23px;
     font-size: 13px
 }
 .memberbtn1 {
     width: 10%;
     font-size: 13px;
     text-align: right;
 }

 .card-item {
     display: flex;
     flex-direction: column;
     /*justify-content: space-between;*/
     font-size: 10px;
     padding-bottom: 8px;
 }
 .kaneirong{
     width: 100%;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     align-items: center;
 }
 .cardname{
     width: 50%;
     line-height: 20px
 }
 .kaye{
     width: 50%;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     margin-top: 10px;
 }
 .djnr{
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .kdimg{
     width: 12px;
     height: 12px;
     margin-right: 3px;
 }
 .bkimg{
     width: 13px;
     height: 13px;
     margin-right: 3px;
 }
</style>